module.exports = {"thumbnail":"https://wnow-modules.s3.amazonaws.com/icon_stroke_news_articlelist.svg","tag":"GNM Other","affiliates":["kotv","kwtv"],"propTypes":{"affiliate":"PropTypes.string"},"defaultProps":{"affiliate":"kotv"},"propChoices":{"affiliate":["kotv","kwtv"]},"FRN_resourceEndpoints":[{"url":"http://ftpcontent.worldnow.com/kotv/custom/tracking/traffic.js","type":"jsonp"}]}


//////////////////
// WEBPACK FOOTER
// ./app/components/custom/ssr/TrafficPage/package.json
// module id = 1831
// module chunks = 0